<mat-toolbar color="primary">Restore Deleted Media</mat-toolbar>

<mat-dialog-content class="min-h-[200px]">
  @if (loading$ | async) {
    <div
      class="flex flex-col items-center justify-center px-4 py-8 text-black/60"
    >
      <mat-spinner diameter="40" />
      <p class="mt-4 text-sm">Loading deleted media...</p>
    </div>
  } @else if ((deletedMediaItems$ | async)?.length) {
    <div class="flex items-center px-4 pt-2">
      <mat-checkbox
        [checked]="allSelected()"
        (change)="toggleSelectAll()"
        [disabled]="restoring()"
      >
        Select All
      </mat-checkbox>
    </div>
    <mat-selection-list
      #mediaList
      (selectionChange)="onSelectionChange(mediaList.selectedOptions.selected)"
    >
      @for (item of deletedMediaItems$ | async; track item.media.ref.path) {
        <mat-list-option [value]="item">
          <mat-icon matListItemIcon>insert_drive_file</mat-icon>
          <span matListItemTitle>{{ item.media.name }}</span>
          <span matListItemLine
            >Deleted: {{ item.deletedAt | date: 'medium' }}</span
          >
        </mat-list-option>
      }
    </mat-selection-list>
  } @else {
    <div
      class="flex flex-col items-center justify-center px-4 py-8 text-black/[0.38]"
    >
      <mat-icon
        fontSet="material-symbols-outlined"
        class="mb-4 !h-12 !w-12 !text-5xl"
        >folder_open</mat-icon
      >
      <p class="m-0 text-sm">No deleted media found for this patient.</p>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" mat-button mat-dialog-close [disabled]="restoring()">
    Cancel
  </button>
  <button
    type="button"
    mat-flat-button
    color="primary"
    [disabled]="!selectedItems().length || restoring()"
    (click)="restoreSelected()"
  >
    @if (restoring()) {
      <mat-spinner class="mr-2 inline-block" diameter="18" />
    }
    Restore Selected
  </button>
</mat-dialog-actions>
